import React from 'react';
import { Text } from '@chakra-ui/react';

// Serif title treatment shared by every variant. On the post card the title is a kicker
// above the body rather than the headline — the body carries the emphasis there — so the
// size is caller-controlled.
const LoopTitle = ({
  children,
  isOnDark = false,
  fontSize = { base: '18px', md: '20px' },
}: {
  children: React.ReactNode;
  isOnDark?: boolean;
  fontSize?: React.ComponentProps<typeof Text>['fontSize'];
}) => (
  <Text
    fontFamily="Lora"
    fontStyle="italic"
    fontWeight={600}
    fontSize={fontSize}
    lineHeight="1.3"
    color={isOnDark ? 'white' : 'text.darkBlue'}
  >
    {children}
  </Text>
);

export default LoopTitle;
